"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.isOSWEnabled = exports.getExternalIDForProvider = exports.getExtVisitTypeForProvider = exports.getExtIDFromProviderExtID = exports.getEpicOSWConfig = exports.getDefaultVisitTypeFromConfig = void 0;
var _find = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/find"));
var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));
var _Filters = require("./constants/Filters");
var _EpicOSW = require("./constants/EpicOSW");
/**
 * Looks for the epic_osw config in the PMCDB config object
 * @param {Object} config The PMCDB config object from CS
 * @returns {Object} The config object that contains the URLs to the host, CSS, JS, etc.
 * @returns {null} If not found
 */
const getEpicOSWConfig = config => {
  try {
    return config.third_party_scheduling_configs.epic_osw;
  } catch (e) {
    return null;
  }
};

/**
 *
 * @param {Object} provider The provider data fetched from the provider endpoint
 * @param {Object} epicOSWConfig The epic_osw object from the PMCDB config in CS
 * @returns {Boolean} true if we find the correct config and provider data, false otherwise
 */
exports.getEpicOSWConfig = getEpicOSWConfig;
const isOSWEnabled = (provider, epicOSWConfig) => {
  try {
    // external_id for osw clients looks like 1234321@epic_osw
    const [, epicOSWIdentifier] = provider.external_id.split(_EpicOSW.EXTERNAL_ID_DELIMITER);
    return epicOSWIdentifier === _EpicOSW.EXTERNAL_ID_IDENTIFIER && Boolean(epicOSWConfig);
  } catch (e) {
    // bad data or missing config, default to normal flow
    return false;
  }
};

/**
 * This function will find the appropriate Epic OSW external ID to pass to the iFrame
 * for a given provider. It first checks provider.external_systems and falls back to
 * provider.external_id if not found, which is returned by the getExtIDFromProviderExtID
 * function
 * @param {Object} provider The provider data fetched from the provider endpoint
 * @returns {String} The external ID found in provider.external_systems
 * @returns {String} The result from calling getExtIDFromProviderExtID
 */
exports.isOSWEnabled = isOSWEnabled;
const getExternalIDForProvider = provider => {
  const {
    external_systems
  } = provider;
  if (external_systems) {
    try {
      const epicSystemsData = (0, _find.default)(external_systems).call(external_systems, systemData => {
        return systemData.system_type === _EpicOSW.SYSTEM_TYPE_IDENTIFIER;
      });
      if (epicSystemsData) {
        // return the first one we find
        return epicSystemsData.provider_id;
      } else {
        // no match
        return getExtIDFromProviderExtID(provider);
      }
    } catch (e) {
      // bad data
      return getExtIDFromProviderExtID(provider);
    }
  } else {
    // no external_systems
    return getExtIDFromProviderExtID(provider);
  }
};

/**
 * This function will find the appropriate Epic OSW external ID to pass to the iFrame
 * for a given provider. It parses provider.external_id and returns what it finds or an
 * empty string. This is the fallback for the getExternalIDForProvider function
 * @param {Object} provider The provider data fetched from the provider endpoint
 * @returns {String} The external ID found in provider.external_id
 * @returns {String} Empty string if no external_id or does not match format
 */
exports.getExternalIDForProvider = getExternalIDForProvider;
const getExtIDFromProviderExtID = provider => {
  const {
    external_id
  } = provider;
  if (external_id) {
    // external_id for osw clients looks like 1234321@epic_osw
    try {
      const [externalID, epicOSWIdentifier] = provider.external_id.split(_EpicOSW.EXTERNAL_ID_DELIMITER);
      if (epicOSWIdentifier === _EpicOSW.EXTERNAL_ID_IDENTIFIER) {
        return externalID;
      } else {
        return '';
      }
    } catch (e) {
      // bad data
      return '';
    }
  } else {
    // no external_id
    return '';
  }
};

/**
 * Finds the appropriate visit type ID to pass to the OSW iFrame (vt param). First checks
 * provider.appointment_ehr_purposes and falls back to the default_visit_type found in the
 * CS config, which is returned by getDefaultVisitTypeFromConfig
 * @param {Object} provider The provider data fetched from the proivder endpoint
 * @param {Object} epicOSWConfig The epic_osw object fetched from the CS config
 * @returns {String} The visit type ID to pass to the OSW iFrame (vt param)
 * @returns {String} The result from calling getDefaultVisitTypeFromConfig if we do not find a result in the ehr_data
 */
exports.getExtIDFromProviderExtID = getExtIDFromProviderExtID;
const getExtVisitTypeForProvider = (provider, epicOSWConfig) => {
  const {
    appointment_ehr_purposes
  } = provider;
  if (appointment_ehr_purposes && appointment_ehr_purposes.length !== 0) {
    try {
      let visitTypeMatches = [];
      (0, _forEach.default)(appointment_ehr_purposes).call(appointment_ehr_purposes, _ref => {
        let {
          ehr_data
        } = _ref;
        const validVisitType = (0, _find.default)(ehr_data).call(ehr_data, _ref2 => {
          let {
            visibilities
          } = _ref2;
          return visibilities.consumer === _Filters.DIRECT_BOOK;
        });
        if (validVisitType) {
          visitTypeMatches.push(validVisitType.book_as_type_id);
        }
      });
      if (visitTypeMatches.length > 0) {
        // return the first one we found
        return visitTypeMatches[0];
      } else {
        // no matches
        return getDefaultVisitTypeFromConfig(epicOSWConfig);
      }
    } catch (e) {
      // bad data
      return getDefaultVisitTypeFromConfig(epicOSWConfig);
    }
  } else {
    // no appointment_ehr_purposes
    return getDefaultVisitTypeFromConfig(epicOSWConfig);
  }
};

/**
 * Returns the default_visit_type_id from the epic_osw object
 * @param {Object} epicOSWConfig The epic_osw object from CS
 * @returns {String} The default_visit_type_id
 * @returns {String} Empty string if no default_visit_type_id found
 */
exports.getExtVisitTypeForProvider = getExtVisitTypeForProvider;
const getDefaultVisitTypeFromConfig = epicOSWConfig => {
  if (epicOSWConfig && epicOSWConfig.default_visit_type_id) {
    return epicOSWConfig.default_visit_type_id;
  } else {
    return '';
  }
};
exports.getDefaultVisitTypeFromConfig = getDefaultVisitTypeFromConfig;